export const WorkPackageWIPMixin = {
  data: () => ({
    dynamic_width: {
      width: 0, // actual dynamic width, refer to this!
      container_name: '', // id of container the width is based on
      items_per_row: 5, // item count per row, control any items % items_per_row != 0 with justify-content
      row_space: 8, // grid gap of parent flexbox
      multiple_of: 0, // optional - for perfect multiple of number width
      delta_offsetWidth: 0,
    },

    radio_btns: {
      active_btn: '', // id of single active button
      is_deselectable: false, // toggles if a radio button can be deselected by clicking it again
      is_emit: false, // toggles weather the component should emit or call an method
    },

    light_mode: {
      delta_foreground_color: '',
      delta_light_mode: '',
    }
  }),

  methods: {
    // dynamic_width: inits dynamic width, call this in mount()
    // initDynWidth(container_name, items_per_row, row_space, multiple_of) {
    //   this.dynamic_width.container_name = container_name;
    //   this.dynamic_width.items_per_row = items_per_row;
    //   this.dynamic_width.row_space = row_space;
    //   this.dynamic_width.multiple_of = multiple_of;
    //   window.addEventListener('resize', this.calcDynWidth);
    //   window.addEventListener('transitionend', this.calcDynWidth);
    //   this.calcDynWidth();
    // },

    // dynamic_width: calculates dynamic_width initially and whenever the screen is being resized
    // calcDynWidth() { // there are always the same amount of elements in a line, element dimensions are dynamic
    //   let dw = this.dynamic_width;
    //   // TODO: free_space shouldn't depend on getElementById
    //   let free_space = document.getElementById(dw.container_name).offsetWidth; // is width of wrapping container
    //   let items_per_row = dw.items_per_row; // is target count of items per row, control any items % items_per_row != 0 with justify-content
    //   let row_space = dw.row_space; // is "grid-gap" of parent css class with flex attribute
    //
    //   let width = (free_space - ((items_per_row - 1) * row_space)) / items_per_row;
    //   if(dw.multiple_of) { width = Math.floor(width); width -= width % dw.multiple_of; } // makes sure width is floored int, makes width a multiple of multiple_of
    //
    //   dw.width = width;
    // },

    // radio_btns: inits radio buttons, call this in mount()
    // initRadioBtns(is_deselectable, is_emit, default_btn) {
    //   this.radio_btns.is_deselectable = is_deselectable;
    //   this.radio_btns.is_emit = is_emit;
    //   this.radio_btns.active_btn = default_btn;
    // },

    // radio_btns: sets active btn and either emits or calls methods on select/deselect events
    // setRadioBtnActive(origin) {
    //   let rb = this.radio_btns;
    //   if(origin != rb.active_btn) { // if a new button is clicked
    //     rb.active_btn = origin; // set it as the new single active button
    //     if(rb.is_emit) {
    //       this.$emit('radioButtonSelected', origin); // @radioButtonSelected may exist in parent
    //     }
    //     else {
    //       this.handleRadioButtonSelected(origin); // method must exist in component
    //     }
    //   }
    //   else if(rb.is_deselectable){ // else the active button got clicked again - if toggled deselect
    //     rb.active_btn = '';
    //     if(rb.is_emit) {
    //       this.$emit('radioButtonDeselected', origin); // @radioButtonDeselected may exist in parent
    //     }
    //     else {
    //       this.handleRadioButtonDeselected(origin); // method must exist in component
    //     }
    //   }
    // },

    // transparent colors: call this when you want 'hex_color' to be 'opacity' percent opaque
    // hex_color is color in format of '#FFF', '#FFFFFF' (no transparency), '#FFFF', '#FFFFFFFF' (existing transparency)
    getTranspHexColor(hex_color, opacity) {
      // existing transparency gets discarded
      if(hex_color.length == 5) { hex_color = hex_color.slice(0, 4); }
      if(hex_color.length == 9) { hex_color = hex_color.slice(0, 7); }

      // checks if hex_color is a valid hexadecimal color value
      var legal_chars = /[0-9A-Fa-f]/g;
      if(hex_color[0] != '#' || !(hex_color.length == 4 || hex_color.length == 7) || !legal_chars.test(hex_color)) {
        return '#888';
      }

      let hex_opacity;
      if(opacity === undefined) { opacity = .5 }
      if(hex_color.length == 4) { // if format is '#FFF' we can only increment by 1/16th
        hex_opacity = parseInt(15 * opacity).toString(16).toUpperCase();
      }
      else { // if format is '#FFFFFF' we can increment by 1/256th
        hex_opacity = parseInt(255 * opacity).toString(16).toUpperCase();
        if(hex_opacity.length != 2) { hex_opacity = '0' + hex_opacity }
      }

      return`${hex_color}${hex_opacity}`;
    },

    // hsl as object of hex color: call this when you need hsl values of hex color for example to check for luminosity
    // hex_color is color in format of '#FFF', '#FFFFFF' (no transparency), '#FFFF', '#FFFFFFFF' (existing transparency)
    getHexToHsl(hex_color) {
      // existing transparency gets discarded
      if(hex_color.length == 5) { hex_color = hex_color.slice(0, 4); }
      if(hex_color.length == 9) { hex_color = hex_color.slice(0, 7); }

      // checks if hex_color is a valid hexadecimal color value
      var legal_chars = /[0-9A-Fa-f]/g;
      if(hex_color[0] != '#' || !(hex_color.length == 4 || hex_color.length == 7) || !legal_chars.test(hex_color)) {
        return { h: 0, s: 50, l: 50};
      }

      // https://css-tricks.com/converting-color-spaces-in-javascript/
      // Convert hex to RGB first
      let r = 0, g = 0, b = 0;
      if (hex_color.length == 4) {
        r = "0x" + hex_color[1] + hex_color[1];
        g = "0x" + hex_color[2] + hex_color[2];
        b = "0x" + hex_color[3] + hex_color[3];
      } else if (hex_color.length == 7) {
        r = "0x" + hex_color[1] + hex_color[2];
        g = "0x" + hex_color[3] + hex_color[4];
        b = "0x" + hex_color[5] + hex_color[6];
      }

      // Then to HSL
      r /= 255;
      g /= 255;
      b /= 255;
      let cmin = Math.min(r,g,b),
          cmax = Math.max(r,g,b),
          delta = cmax - cmin,
          h = 0,
          s = 0,
          l = 0;

      if (delta == 0)
        h = 0;
      else if (cmax == r)
        h = ((g - b) / delta) % 6;
      else if (cmax == g)
        h = (b - r) / delta + 2;
      else
        h = (r - g) / delta + 4;

      h = Math.round(h * 60);

      if (h < 0)
        h += 360;

      l = (cmax + cmin) / 2;
      s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
      s = +(s * 100).toFixed(1);
      l = +(l * 100).toFixed(1);
      return { h: h, s: s, l: l};
    },

    // sorts an array of objects alphabetically by a (string) value of a specific key
    sortObjectArrayByValueOfKey(array, sort_key) {
      array.sort((a, b) => {
        // we check every char if they're the same, if not sort accordingly
        // TODO: check for ö, ä, ü, ß
        let min = Math.min(a[sort_key].length, b[sort_key].length);
        for(let i = 0; i < min; i++) {

          if(a[sort_key][i].toLowerCase() !== b[sort_key][i].toLowerCase()) {
            return a[sort_key][i].toLowerCase() > b[sort_key][i].toLowerCase() ? 1 : -1;
          }
        }

        // all chars were the same, shorter string is prioritized
        if(a[sort_key].length != b[sort_key].length) {
          return a[sort_key].length === min ? -1 : 1;
        }

        // string matches exactly, no preference
        return 0;
      });
    },

    // returns the day of the week in english, day_index is part of a date-object
    getWeekdayString(day_index) {
      switch (day_index) {
        case 0:
          return 'Sunday';
        case 1:
          return 'Monday';
        case 2:
          return 'Tuesday';
        case 3:
          return 'Wednesday';
        case 4:
          return 'Thursday';
        case 5:
          return 'Friday';
        case 6:
          return 'Saturday';
        default:
          return '';
      }
    },

    // returns the name of a month in english, month_index is part of a date-object
    getMonthString(month_index) {
      switch (month_index) {
        case 0:
          return 'January';
        case 1:
          return 'February';
        case 2:
          return 'March';
        case 3:
          return 'April';
        case 4:
          return 'May';
        case 5:
          return 'June';
        case 6:
          return 'July';
        case 7:
          return 'August';
        case 8:
          return 'September';
        case 9:
          return 'October';
        case 10:
          return 'November';
        case 11:
          return 'December';
        default:
          return '';
      }
    },

    // returns a boolean which evaluates if light mode (true) or dark mode (false) should be used
    is_light_mode(foreground_color) {
      let lm = this.light_mode;
      if(lm.delta_light_mode === '' || lm.delta_foreground_color != foreground_color) {
        lm.delta_foreground_color = foreground_color;
        lm.delta_light_mode = this.getHexToHsl(foreground_color).l < 50;
      }
      return lm.delta_light_mode;
    },

    // returns a materialdesignicon for a given type
    getStepIcon(type) {
      return this.$store.state.Ultra.step_icons[type.toLowerCase()];
    },
  },

  // dynamic_width: makes sure the event listener that has been called in initDynWidth gets removed
  beforeRouteLeave(to, from, next) {
    if(this.dynamic_width.container_name) { // if dynamic_width was initialized
      window.removeEventListener('resize', this.calcDynWidth);
      window.removeEventListener('transitionend', this.calcDynWidth);
    }
    next();
  },
};
